<template>
    <div 
        :class="prefixCls">
        <div :class="prefixCls + '-inner'">
            <i :class="`${prefixCls}-dot-item`"></i>
            <i :class="`${prefixCls}-dot-item`"></i>
            <i :class="`${prefixCls}-dot-item`"></i>
            <i :class="`${prefixCls}-dot-item`"></i>
        </div>
        <div :class="prefixCls + '-text'">{{text}}</div>
    </div>
</template>
<script>
    import { t } from '../../../locale/'

    const prefixCls = 'yy-loading-h'
    export default {
        name: 'YYLoadingH',
        props: {
            text: {
                type: String,
                default: function() {
                    return t('loading')
                }
            }
        },
        data() {
            return {
                prefixCls
            }
        }
    }
</script>
